import classNames from 'classnames';
import React, { FCC } from 'react';
import { ITabProps } from './types';

/**
 * `Tab` is a child of `Tabs`.
 */
export const Tab: FCC<ITabProps> = (props) => {
  const { active, children } = props;
  const classes = classNames('tab-pane', { active });
  return (
    <div role={'tabpanel'} className={classes}>
      {children}
    </div>
  );
};

export default Tab;
